import {connect} from 'react-redux'
import {selectProblem} from '../../../redux/modules/grandmaster'
import {makeSelectTopic} from '../../../redux/modules/topic'
import {toJS} from '../../../util/ToJS'
import StreakMeter from '../components/StreakMeter'

const makeMapStateToProps = () => {
  const selectTopic = makeSelectTopic()
  const mapStateToProps = state => {
    const topic = selectTopic(state)
    const gmProblem = selectProblem(state)
    let subjectColorId = topic.get('id')
    if (topic.get('breadcrumbs').size) {
      subjectColorId = topic.getIn(['breadcrumbs', 0, 'id'])
    }
    return {
      subjectColorId: subjectColorId,
      streak: gmProblem.streak,
      bestStreak: gmProblem.bestStreak
    }
  }
  return mapStateToProps
}
export default connect(
  makeMapStateToProps
)(toJS(StreakMeter))



// WEBPACK FOOTER //
// ./src/domains/grandmaster/containers/VisibleStreakMeter.js